"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EasyAddConfigModel", {
    enumerable: true,
    get: function() {
        return EasyAddConfigModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const EasyAddConfigModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    approval: _zod.z.boolean(),
    author_due_date: _zod.z.string(),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    deleted_at: _zod.z.string(),
    due_date_types: _zod.z.string(),
    formID: _zod.z.instanceof(_bson.ObjectId),
    formObject: _zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    }),
    is_active: _zod.z.boolean(),
    modified_at: _zod.z.date(),
    redact: _zod.z.boolean(),
    signer_due_date: _zod.z.string(),
    subject_employee_choose_author: _zod.z.string(),
    unsaved: _zod.z.boolean(),
    visibility: _zod.z.boolean(),
    who_can_add_form: _zod.z.object({
        any_employee: _zod.z.boolean(),
        subject: _zod.z.boolean(),
        manager_or_chain_of_command: _zod.z.boolean(),
        admin_or_group_admin: _zod.z.boolean()
    }),
    who_signs_off: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    }))
});
